import React from 'react';
import {
  FiBookOpen,
  FiHeadphones,
  FiEdit2,
  FiMic,
  FiArrowRight,
} from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import './Tips.css';

const TIPS_DATA = {
  reading: {
    icon: <FiBookOpen />,
    title: 'Reading Tips',
    description: 'Master IELTS/TOEFL reading with proven strategies',
    tips: [
      'Skim passages quickly for main ideas',
      'Practice time management - 20 minutes per passage',
      'Focus on topic sentences and conclusions',
      'Learn to identify key supporting details',
      'Practice scanning for specific information',
    ],
  },
  writing: {
    icon: <FiEdit2 />,
    title: 'Writing Tips',
    description: 'Improve your writing score with these techniques',
    tips: [
      'Plan your essay before writing',
      'Use clear topic sentences and transitions',
      'Support main ideas with specific examples',
      'Vary your sentence structure',
      'Review grammar and punctuation',
    ],
  },
  listening: {
    icon: <FiHeadphones />,
    title: 'Listening Tips',
    description: 'Enhance your listening comprehension skills',
    tips: [
      'Take effective notes while listening',
      'Focus on main ideas and key details',
      'Pay attention to transition words',
      'Listen for tone and attitude',
      'Practice with different accents',
    ],
  },
  speaking: {
    icon: <FiMic />,
    title: 'Speaking Tips',
    description: 'Build confidence and fluency in spoken English',
    tips: [
      'Practice speaking for 2 minutes on any topic',
      'Use linking words to connect your ideas',
      'Develop your ideas with examples',
      'Speak clearly at a natural pace',
      'Record yourself and review for improvement',
    ],
  },
};

export default function Tips({ category, onClose }) {
  const navigate = useNavigate();
  const tipData = TIPS_DATA[category];

  if (!tipData) return null;

  return (
    <div className="tips-card">
      <div className="tips-header">
        <span className="tips-icon">{tipData.icon}</span>
        <div>
          <h2 className="tips-title">{tipData.title}</h2>
          <p className="tips-description">{tipData.description}</p>
        </div>
      </div>

      <ul className="tips-list">
        {tipData.tips.map((tip, index) => (
          <li key={index} className="tips-item">
            {tip}
          </li>
        ))}
      </ul>

      <button
        className="tips-view-all"
        onClick={() => navigate(`/exams/english/${category}-tips/`)}
      >
        View all Tips to master the{' '}
        {category.charAt(0).toUpperCase() + category.slice(1)} part of the test
        <FiArrowRight />
      </button>
    </div>
  );
}
